import React from "react";

import { DecisionCards, DecisionCardOption } from "./DecisionCards";

export interface QuestionCardProps {
  /** The question itself, e.g. "Can Zournal connect to this client's accounting system?" */
  headline: string;
  /** One line explaining why we ask. */
  whyLine: string;
  /** Each option's `description` is what happens if chosen — no preselection. */
  options: DecisionCardOption[];
  selected: string | undefined;
  onSelect: (value: string) => void;
}

// The onboarding-question format: headline + why-line + single-select radio
// cards, each naming its own consequence. No result is ever pre-selected, so
// Continue stays disabled until the user actively picks.
export function QuestionCard({ headline, whyLine, options, selected, onSelect }: QuestionCardProps) {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <h3 className="text-base font-medium">{headline}</h3>
        <p className="text-sm text-muted-foreground">{whyLine}</p>
      </div>
      <DecisionCards options={options} selected={selected ? [selected] : []} onToggle={onSelect} multiple={false} />
    </div>
  );
}
